

import axios from "axios";
import { OutputBaseProps } from "utils/types/API";
import { AppMessage } from "components";

interface ApiAuthChangePasswordInputProps {
    password: string;
    newPassword: string;
    retypePassword: string;
}

type ApiAuthChangePasswordOutputProps = OutputBaseProps<{ changed: number }>

export const apiAuthChangePassword = async (data: ApiAuthChangePasswordInputProps) => {
    const res = (await axios.put<ApiAuthChangePasswordOutputProps>("/api/auth/change-password", data))
        .data;
    if (res.code === 0 && res.data) {
        AppMessage.success({
            title: "Thông báo",
            message: res.message
        })
    }
    return res;
};